import axios from 'axios';
import SecureLS from 'secure-ls'

const ls = new SecureLS({encodingType: 'aes'})

// Create Axios instance with base URL
const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL, // Update the backend API URL
});

// Interceptor to include token in headers
api.interceptors.request.use((config) => {
    const token = ls.get('jwt');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;
